var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6498 6.35C17.1998 4.9 15.2098 4 12.9998 4C8.57977 4 5.00977 7.58 5.00977 12C5.00977 16.42 8.57977 20 12.9998 20C16.7298 20 19.8398 17.45 20.7298 14H18.6498C17.8298 16.33 15.6098 18 12.9998 18C9.68977 18 6.99977 15.31 6.99977 12C6.99977 8.69 9.68977 6 12.9998 6C14.6598 6 16.1398 6.69 17.2198 7.78L13.9998 11H20.9998V4L18.6498 6.35Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.3c0ecf8b02760a98473fd3d8e6fd8b7a.svg";
export { ForwardRef as ReactComponent };